import React from 'react';
import { useRoutes } from 'react-router-dom';
import Cookies from 'js-cookie';
import protectedRoutes from './protected';
import publicRoutes from './public';
import SafetyloopImport from '../components/SafetyloopImport';

function AppRoutes() {
  const auth = Cookies.get('auth-token') ? 'Yes' : 'No';
  const routes = auth === 'Yes' ? protectedRoutes : publicRoutes;
  // const routes = protectedRoutes;
  const element = useRoutes([...routes]);
  if (auth === 'Yes') {
    // Mounted once beside every protected page; it renders nothing unless the
    // API says this SafetyLoop-linked admin has no projects yet.
    return (
      <>
        {element}
        <SafetyloopImport />
      </>
    );
  }
  return <>{element}</>;
}

export default AppRoutes;
